/** Parse video id from YouTube video link. */
export default function getYouTubeVideoId(value: string | undefined) {
	if (!value) return undefined
	try {
		return new URL(String(value)).searchParams.get('v')
	} catch (error) {
		return undefined
	}
}
